import React from 'react';

type SvgsellingProps = React.SVGProps<SVGSVGElement>;

const Svgselling: React.FC<SvgsellingProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_969_5454)">
      <path
        d="M21.6133 3.32189V2.3887C21.6133 1.07156 20.5417 0 19.2246 0H12.5812C11.9431 0 11.3433 0.248484 10.8921 0.699703L1.49658 10.0953C1.04536 10.5465 0.796875 11.1463 0.796875 11.7844C0.796875 12.4224 1.04536 13.0223 1.49658 13.4735L2.45128 14.4282C2.41025 14.6056 2.38949 14.7872 2.38941 14.9693C2.38941 15.6074 2.63789 16.2073 3.08911 16.6584L9.73237 23.3016C10.198 23.7672 10.8097 24 11.4214 24C12.0331 24 12.6448 23.7672 13.1105 23.3015L22.5061 13.9058C22.9573 13.4546 23.2058 12.8548 23.2058 12.2167V5.57363C23.2058 4.53562 22.54 3.65058 21.6133 3.32189ZM2.62261 12.3474C2.54843 12.2736 2.48962 12.1859 2.44959 12.0892C2.40955 11.9926 2.38908 11.8889 2.38936 11.7843C2.38909 11.6797 2.40956 11.5761 2.4496 11.4794C2.48963 11.3828 2.54844 11.295 2.62261 11.2213L12.0182 1.82569C12.092 1.75153 12.1797 1.69274 12.2764 1.65271C12.373 1.61268 12.4766 1.59221 12.5813 1.59248H19.2246C19.6636 1.59248 20.0208 1.94967 20.0208 2.3887V3.18492H14.1737C13.5356 3.18492 12.9358 3.43341 12.4846 3.88462L3.32231 13.047L2.62261 12.3474ZM21.3801 12.7798L11.9844 22.1754C11.6739 22.4859 11.1688 22.4858 10.8584 22.1754L4.21509 15.5323C4.14092 15.4585 4.08211 15.3708 4.04207 15.2741C4.00203 15.1775 3.98156 15.0739 3.98184 14.9692C3.98157 14.8646 4.00204 14.761 4.04208 14.6644C4.08212 14.5677 4.14092 14.48 4.21509 14.4062L13.6107 5.01056C13.6845 4.9364 13.7722 4.87761 13.8689 4.83758C13.9655 4.79755 14.0691 4.77709 14.1737 4.77736H20.817C21.2561 4.77736 21.6133 5.13455 21.6133 5.57358V12.2167C21.6133 12.4294 21.5304 12.6294 21.3801 12.7798Z"
        fill="#5F6D7E"
      />
      <path
        d="M17.6309 6.37012C16.3137 6.37012 15.2422 7.44168 15.2422 8.75882C15.2422 10.076 16.3137 11.1475 17.6309 11.1475C18.948 11.1475 20.0196 10.076 20.0196 8.75882C20.0196 7.44168 18.948 6.37012 17.6309 6.37012ZM17.6309 9.55509C17.1919 9.55509 16.8347 9.1979 16.8347 8.75887C16.8347 8.31984 17.1919 7.96265 17.6309 7.96265C18.0699 7.96265 18.4271 8.31984 18.4271 8.75887C18.4271 9.1979 18.0699 9.55509 17.6309 9.55509Z"
        fill="#5F6D7E"
      />
    </g>
    <defs>
      <clipPath id="clip0_969_5454">
        <rect height="24" width="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Svgselling;
